import React, { useState, useRef } from 'react';
import { Box } from '@mui/material';
import { Modal } from 'antd';
import NewsList from '../components/news/NewsList';
import NewsForm from '../components/news/NewsForm';
import PageHeader from '../components/common/PageHeader';
import { ArticleOutlined as NewsIcon } from '@mui/icons-material';

const NewsPage = () => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const listRef = useRef();

  const handleEdit = (item) => {
    setSelectedItem(item);
    setIsModalVisible(true);
  };

  const handleSuccess = () => {
    setIsModalVisible(false);
    setSelectedItem(null);
    listRef.current?.refresh();
  };

  return (
    <Box className="premium-container">
      <PageHeader
        title="Latest News"
        subtitle="Manage announcements, updates, and news articles for the organization."
        titleIcon={<NewsIcon />}
        btnText="ADD NEWS"
        onBtnClick={() => {
          setSelectedItem(null);
          setIsModalVisible(true);
        }}
      />

      <Box className="premium-table-card">
        <NewsList ref={listRef} onEdit={handleEdit} />
      </Box>

      <Modal
        title={selectedItem ? 'Edit News' : 'Add News'}
        open={isModalVisible}
        onCancel={() => {
          setIsModalVisible(false);
          setSelectedItem(null);
        }}
        footer={null}
        width={800}
      >
        <NewsForm
          initialValues={selectedItem}
          onSuccess={handleSuccess}
          onCancel={() => {
            setIsModalVisible(false);
            setSelectedItem(null);
          }}
        />
      </Modal>
    </Box>
  );
};

export default NewsPage;
